export const COLLECTION_READY_MESSAGE_TYPE = 'vieunite:collection:ready';
export const COLLECTION_READY_MESSAGE_VERSION = 1;
export const COLLECTION_READY_TIMEOUT_MS = 12000;
export const PRODUCTION_COLLECTION_URL = 'https://collection.vieunite.com/collection';
export const TEST_COLLECTION_URL = 'https://collection-test.vieunite.com/collection';
const COLLECTION_PRECONNECT_MARKER = 'data-vieunite-collection-preconnect';

const COLLECTION_URLS_BY_ENVIRONMENT = {
    production: PRODUCTION_COLLECTION_URL,
    test: TEST_COLLECTION_URL,
};

const normaliseConfiguredUrl = (configuredUrl) => {
    if (typeof configuredUrl !== 'string' || !configuredUrl.trim()) return null;

    try {
        const url = new URL(configuredUrl.trim());
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
        return url.toString();
    } catch (_error) {
        return null;
    }
};

const getConfiguredEnvironmentUrl = (environment) => {
    if (typeof environment !== 'string') return PRODUCTION_COLLECTION_URL;

    const normalisedEnvironment = environment.trim().toLowerCase();
    return COLLECTION_URLS_BY_ENVIRONMENT[normalisedEnvironment] || PRODUCTION_COLLECTION_URL;
};

export const getCollectionEmbedUrl = ({
    configuredUrl = process.env.REACT_APP_COLLECTION_EMBED_URL,
    environment = process.env.REACT_APP_COLLECTION_ENVIRONMENT,
} = {}) => {
    const normalisedConfiguredUrl = normaliseConfiguredUrl(configuredUrl);
    if (normalisedConfiguredUrl) return normalisedConfiguredUrl;

    return getConfiguredEnvironmentUrl(environment);
};

export const preconnectCollectionEmbed = ({
    collectionUrl = getCollectionEmbedUrl(),
    documentLike = typeof document !== 'undefined' ? document : null,
} = {}) => {
    if (!documentLike?.head) return null;

    const collectionOrigin = new URL(collectionUrl).origin;
    const existing = Array.from(
        documentLike.head.querySelectorAll(`link[${COLLECTION_PRECONNECT_MARKER}]`),
    ).find((link) => link.href === `${collectionOrigin}/` || link.href === collectionOrigin);
    if (existing) return existing;

    const link = documentLike.createElement('link');
    link.rel = 'preconnect';
    link.href = collectionOrigin;
    link.setAttribute(COLLECTION_PRECONNECT_MARKER, '');
    documentLike.head.appendChild(link);
    return link;
};

export const isTrustedCollectionReadyMessage = ({event, frameWindow, expectedOrigin}) => (
    Boolean(frameWindow)
    && event.source === frameWindow
    && event.origin === expectedOrigin
    && event.data?.type === COLLECTION_READY_MESSAGE_TYPE
    && event.data?.version === COLLECTION_READY_MESSAGE_VERSION
);
